import React, { useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  IconButton,
  TextField,
} from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import ViewListTwoToneIcon from "@mui/icons-material/ViewListTwoTone";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import RouteImportButton from "@/features/route/RouteImportButton.jsx";
import MessageDialog from "@/components/ui/MessageDialog.jsx";

export default function RouteTreeToolbar({
  vesselSearchTerm,
  onSearchChange,
  onSearchClear,
  onImportDraft,
}) {
  const [importError, setImportError] = useState("");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "stretch" }}>
        <RouteImportButton
          buttonLabel="Import route"
          onDraftReady={onImportDraft}
          onError={(err) => setImportError(err?.message ?? String(err))}
          buttonSx={{
            width: "100%",
            borderRadius: "12px",
            px: 1.25,
            py: 0.25,
            minHeight: 30,
          }}
        />
      </Box>

      <MessageDialog
        open={Boolean(importError)}
        title="Import failed"
        message={importError}
        onClose={() => setImportError("")}
      />

      <TextField
        size="small"
        fullWidth
        placeholder="Search vessel..."
        value={vesselSearchTerm}
        onChange={onSearchChange}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
          },
        }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 16, color: "rgba(0,79,125,0.7)" }} />
              </InputAdornment>
            ),
            endAdornment: vesselSearchTerm ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={onSearchClear}
                  edge="end"
                  sx={{ p: 0.25 }}
                >
                  <CloseIcon sx={{ fontSize: 14 }} />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
          htmlInput: {
            style: { fontSize: "13px" },
          },
        }}
      />
    </Box>
  );
}
